import React, { useState, useEffect } from 'react';
import styles from './RotateNotification.module.css';

function RotateNotification() {
  const [showNotification, setShowNotification] = useState(false);

  useEffect(() => {
    const checkOrientation = () => {
      // Check if it's a mobile device
      const isTouchDevice = (
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
      );
      
      const isSmallScreen = window.matchMedia('(max-width: 768px)').matches;
      const isPortrait = window.matchMedia('(orientation: portrait)').matches;
      
      // Show notification only if mobile AND portrait
      const shouldShow = isTouchDevice && isSmallScreen && isPortrait;
      setShowNotification(shouldShow);
    };

    // Initial check
    checkOrientation();

    // Listen for orientation changes
    window.addEventListener('resize', checkOrientation);
    window.addEventListener('orientationchange', checkOrientation);

    return () => {
      window.removeEventListener('resize', checkOrientation);
      window.removeEventListener('orientationchange', checkOrientation);
    };
  }, []);

  if (!showNotification) return null;

  return (
    <div className={styles.rotateNotification}>
      <div className={styles.content}>
        <div className={styles.icon}>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77c-.59-.59-1.54-.59-2.12 0L1.75 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-7.31.29C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z"/>
          </svg>
        </div>
        <h2>Rotate Your Device</h2>
        <p>Please rotate your device to landscape mode for the best experience</p>
      </div>
    </div>
  );
}

export default RotateNotification;

